import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "children"],
    _excluded2 = ["children", "size", "isSticky", "isScrollable", "offset", "height"],
    _excluded3 = ["children", "metadata", "title", "count", "description", "actions", "variant", "hasBorder", "hasDivider"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledLayout, StyledLayoutSection, StyledLayoutPanel, StyledLayoutPanelTitle, StyledLayoutPanelDescription, StyledLayoutPanelContent, StyledLayoutPanelMetadata, StyledLayoutPanelHeader, StyledLayoutPanelHeaderActions } from './Layout.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Layout = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-layout"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(StyledLayout, _objectSpread(_objectSpread({
    ref: ref,
    className: className,
    id: id
  }, rest), {}, {
    children: children
  }));
});

var LayoutSection = function LayoutSection(_ref2) {
  var _cx2;

  var children = _ref2.children,
      size = _ref2.size,
      _ref2$isSticky = _ref2.isSticky,
      isSticky = _ref2$isSticky === void 0 ? false : _ref2$isSticky,
      _ref2$isScrollable = _ref2.isScrollable,
      isScrollable = _ref2$isScrollable === void 0 ? false : _ref2$isScrollable,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 16 : _ref2$offset,
      height = _ref2.height,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-layout__section"), true), _defineProperty(_cx2, "".concat(prefix, "-layout__section--scrollable"), isScrollable), _defineProperty(_cx2, "".concat(prefix, "-layout__section--sticky"), isSticky), _cx2));
  return _jsx(StyledLayoutSection, _objectSpread(_objectSpread({
    "data-size": size,
    isSticky: isSticky,
    isScrollable: isScrollable,
    className: className,
    offset: offset,
    height: height
  }, rest), {}, {
    children: children
  }));
};

var LayoutPanel = function LayoutPanel(_ref3) {
  var _cx3;

  var children = _ref3.children,
      metadata = _ref3.metadata,
      title = _ref3.title,
      count = _ref3.count,
      description = _ref3.description,
      actions = _ref3.actions,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'default' : _ref3$variant,
      _ref3$hasBorder = _ref3.hasBorder,
      hasBorder = _ref3$hasBorder === void 0 ? false : _ref3$hasBorder,
      _ref3$hasDivider = _ref3.hasDivider,
      hasDivider = _ref3$hasDivider === void 0 ? false : _ref3$hasDivider,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  var className = cx((_cx3 = {}, _defineProperty(_cx3, "".concat(prefix, "-layout__panel"), true), _defineProperty(_cx3, "".concat(prefix, "-layout__panel--border"), hasBorder), _defineProperty(_cx3, "".concat(prefix, "-layout__panel--divider"), hasDivider), _defineProperty(_cx3, "".concat(prefix, "-layout__panel--").concat(variant), true), _cx3));
  return _jsx(ThemeProvider, {
    theme: {
      variant: variant
    },
    children: _jsxs(StyledLayoutPanel, _objectSpread(_objectSpread({
      className: className
    }, rest), {}, {
      children: [_jsxs(StyledLayoutPanelHeader, {
        className: "".concat(prefix, "-layout__panel-header"),
        children: [metadata && _jsx(StyledLayoutPanelMetadata, {
          children: metadata
        }), title && _jsxs(StyledLayoutPanelTitle, {
          className: "".concat(prefix, "-layout__panel-title"),
          children: [title, ' ', !isNaN(count) && _jsxs("small", {
            children: ["(", count > 0 ? count : 0, ")"]
          })]
        }), description && _jsx(StyledLayoutPanelDescription, {
          className: "".concat(prefix, "-layout__panel-description"),
          children: description
        }), actions && _jsx(StyledLayoutPanelHeaderActions, {
          children: actions
        })]
      }), _jsx(StyledLayoutPanelContent, {
        className: "".concat(prefix, "-layout__panel-content"),
        children: children
      })]
    }))
  });
};

Layout.Section = LayoutSection;
Layout.Panel = LayoutPanel;
export default Layout;
export { LayoutSection, LayoutPanel };